// extracted by mini-css-extract-plugin
export default {"DropdownMenu-menu":"DropdownMenu-menu","svg-symbol":"svg-symbol"};